import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Trash2, ShoppingBag } from 'lucide-react';
import Header from '../components/Header';
import './ShoppingCart.css';

const ShoppingCart = ({ cartItems, removeFromCart, updateQuantity }) => {
    const navigate = useNavigate();
    const { state } = useLocation();

    // Subtotal: sum of all item prices × quantities
    const total = cartItems.reduce((sum, item) => {
        const price = parseFloat(item.price.replace(/[^0-9.-]+/g, ""));
        return sum + price * item.quantity;
    }, 0);


    if (cartItems.length === 0) {
        return (
            <div className="favourites-page">
                <Header
                    leftAction={
                        <button onClick={() => navigate(-1)} className="back-nav">
                            <ArrowLeft size={18} />
                            <span className="nav-text">Back</span>
                        </button>
                    }
                    rightAction={null}
                />
                <div className="cart-container">
                    <div className="cart-card fade-in">
                        <div className="favourites-header">
                            <ShoppingBag size={24} className="cart-icon-pink" />
                            <h1>Your Cart</h1>
                        </div>
                        <div className="empty-cart-content">
                            <div className="empty-icon-placeholder">
                                <ShoppingBag size={64} strokeWidth={1.5} />
                            </div>
                            <h2>Your cart is empty</h2>
                            <p className="empty-subtitle">
                                You haven't added any designs yet.<br />
                                Explore our collection to find something you love.
                            </p>
                            <button className="btn-browse" onClick={() => navigate('/gallery')}>
                                Explore Designs
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cart-page-container">
            <header className="cart-header">
                <button onClick={() => navigate(-1)} className="back-nav">
                    <ArrowLeft size={20} />
                    <span>Back</span>
                </button>
                <h1>Shopping Cart ({cartItems.reduce((sum, item) => sum + item.quantity, 0)})</h1>
            </header>

            <div className="cart-content">
                <div className="cart-items-list">
                    {cartItems.map((item) => (
                        <div key={item.id} className="cart-item-card">
                            <div className="cart-item-image">
                                <img src={item.image} alt={item.title} />
                            </div>
                            <div className="cart-item-details">
                                <h3>{item.title}</h3>
                                <p className="item-category">{item.category}</p>
                                <p className="item-price">{item.price}</p>
                                <div className="item-controls">
                                    <div className="quantity-controls">
                                        <button
                                            onClick={() => updateQuantity(item.id, Math.max(1, item.quantity - 1))}
                                            className="qty-btn"
                                        >
                                            -
                                        </button>
                                        <span className="qty-value">{item.quantity}</span>
                                        <button
                                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                            className="qty-btn"
                                        >
                                            +
                                        </button>
                                    </div>
                                    <button
                                        onClick={() => removeFromCart(item.id)}
                                        className="btn-remove"
                                    >
                                        <Trash2 size={18} />
                                        Remove
                                    </button>
                                </div>
                            </div>
                            <div className="item-total">
                                <p>Total</p>
                                <h3>Rs {parseFloat(item.price.replace(/[^0-9.-]+/g, "")) * item.quantity}</h3>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="cart-summary">
                    <h2>Order Summary</h2>

                    {/* Subtotal row */}
                    <div className="summary-row">
                        <span>Subtotal</span>
                        <span>Rs {total}</span>
                    </div>

                    <div className="summary-divider"></div>

                    {/* Total row - commented out for now, can be re-enabled later */}
                    {/* <div className="summary-total">
                        <span>Total (excluding shipping)</span>
                        <span>Rs {total}</span>
                    </div> */}

                    {/* Checkout button */}
                    <button
                        className="btn-checkout"
                        onClick={() =>
                            navigate('/checkout', {
                                state: {
                                    cartItems,
                                    subtotal: total,
                                    // Carry the origin forward so Checkout can pass it back
                                    from: state?.from || '/gallery',
                                },
                            })
                        }
                    >
                        Proceed to Checkout
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ShoppingCart;
